/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPushSubscription } from '../fn/push-subscriptions/create-push-subscription';
import { CreatePushSubscription$Params } from '../fn/push-subscriptions/create-push-subscription';
import { listPushSubscription } from '../fn/push-subscriptions/list-push-subscription';
import { ListPushSubscription$Params } from '../fn/push-subscriptions/list-push-subscription';
import { PushSubscriptionDto } from '../models/push-subscription-dto';

@Injectable({ providedIn: 'root' })
export class PushSubscriptionsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listPushSubscription()` */
  static readonly ListPushSubscriptionPath = '/v0/pushSubscriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPushSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPushSubscription$Response(params?: ListPushSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PushSubscriptionDto>>> {
    return listPushSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPushSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPushSubscription(params?: ListPushSubscription$Params, context?: HttpContext): Observable<Array<PushSubscriptionDto>> {
    return this.listPushSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PushSubscriptionDto>>): Array<PushSubscriptionDto> => r.body)
    );
  }

  /** Path part for operation `createPushSubscription()` */
  static readonly CreatePushSubscriptionPath = '/v0/pushSubscriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPushSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPushSubscription$Response(params: CreatePushSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createPushSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPushSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPushSubscription(params: CreatePushSubscription$Params, context?: HttpContext): Observable<void> {
    return this.createPushSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
